<template lang="pug">
  v-autocomplete(
    :id='"autocomplete_group"',
    v-model="group",
    :items="groups",
    :get-label='getLabel',
    :component-item='template',
    :input-attrs='attrs',
    :auto-select-one-item='false',
    v-on-clickaway='onClickaway',
    @update-items="updateGroups",
    @item-selected='saveGroup')
</template>

<script>
// Lib autocomplete https://github.com/paliari/v-autocomplete
const listItem = require('./group_item.vue')
const helpers = require('../../../helpers.coffee')
const on_clickaway = require('vue-clickaway')

const view_model = {
  mixins: [ on_clickaway.mixin ],
  props: ['user_id', 'position', 'default_group'],
  data() {
    return {
      show: false,
      current_company: Session.current_company,
      group: this.default_group || null,
      groups: [],
      template: listItem,
      attrs: {
        placeholder: "Digite o nome do grupo"
      }
    }
  },

  methods: {
    setFocus() {
      jQuery(`#${this.id}.v-autocomplete .v-autocomplete-input`).focus()
    },

    onClickaway() {
      this.$emit('hide')
    },

    getLabel(group) {
      return (group != null ? group.name : undefined)
    },

    selectGroup(text) {
      this.group_resources.index(this.searchSuccess, this.unknownError, {params: { page: 1, per: 10, q: { name_cont: text, user_id_eq: this.user_id } }})
    },

    searchSuccess(resources) {
      this.groups = resources.contact_groups
    },

    saveGroup(group) {
      group.position = this.position
      this.$emit('group-selected', group)
    },

    updateGroups(text) {
      this.group_resources.index(this.searchSuccess, this.unknownError, {params: { page: 1, per: 10, q: { name_cont: text, user_id_eq: this.user_id } }})
    }
  },

  
  mounted() {
    this.setFocus()
  },

  created() {
    this.group_resources = new ContactGroupsResource(this.current_company.id)
  }
}
exports.default = helpers.vue_include(view_model, helpers.form)

</script>

<style lang="sass">
  .v-autocomplete
    .v-autocomplete-list
      text-align: left
      border-radius: 2px
      background-color: #ffffff
      border: solid 1px #e6e8ea
      margin-top: 2px
      position: absolute
    .v-autocomplete-list-item
      position: relative
      cursor: pointer
      height: 30px
      width: 342px
      line-height: 30px !important
      background-color: #fff
      padding-left: 12px
      font-size: 10px
      font-weight: normal
      font-style: normal
      font-stretch: normal
      line-height: normal
      letter-spacing: normal
      text-align: justify
      color: #8d99a2

      &:last-child
        border-bottom: none
      &:hover
        background-color: #ededed
        &::before
          position: absolute
          content: " "
          right: 9px
          top: calc(50% - 3.5px)
          width: 7px
          height: 7px
          background-image: url('../../../assets/images/autocomplete-selection-arrow.svg')

  .v-autocomplete-input
    height: 26px
    padding: 6px 8px
    border: 1px solid #C1C8CE
    color: #576876
    border-radius: 3px
    width: 100%
      
  .contact-list-item-stage
    .v-autocomplete
      position: absolute
      z-index: 1
      top: 50px
      left: calc(50% - 230px)

      .v-autocomplete-input-group
        position: relative
        border-radius: 3px
        border: thin #e6e8ea solid
        background: white
        padding: 0
        line-height: 30px

        &:after, &:before
          bottom: 98%
          left: 50%
          border: solid transparent
          content: " "
          height: 0
          width: 0
          position: absolute
          pointer-events: none
          z-index: 1

        &:after
          border-color: rgba(255, 255, 255, 0)
          border-bottom-color: #FFF
          border-width: 10px
          margin-left: -10px

        &:before
          border-color: rgba(230, 232, 234, 0)
          border-bottom-color: #e6e8ea
          border-width: 11px
          margin-left: -11px

        .v-autocomplete-input
          font-size: 10px
          font-weight: normal
          font-style: italic
          font-stretch: normal
          line-height: normal
          letter-spacing: normal
          text-align: justify
          color: #2e4455
          border: none
          width: 460px
          height: 30px
          padding-left: 12px
          color: #7b8e9e
          outline: none

      .v-autocomplete-list
        width: 462px
        text-align: left
        border-radius: 2px
        background-color: #ffffff
        border: solid 1px #e6e8ea
        margin-top: 2px

        .v-autocomplete-list-item
          position: relative
          cursor: pointer
          height: 30px
          line-height: 30px !important
          background-color: #fff
          padding-left: 12px
          font-size: 10px
          font-weight: normal
          font-style: normal
          font-stretch: normal
          line-height: normal
          letter-spacing: normal
          text-align: justify
          color: #8d99a2

          &:last-child
            border-bottom: none
          &:hover
            background-color: #ededed
            &::before
              position: absolute
              content: " "
              right: 9px
              top: calc(50% - 3.5px)
              width: 7px
              height: 7px
              background-image: url('../../../assets/images/autocomplete-selection-arrow.svg')
</style>



// WEBPACK FOOTER //
// groups.vue?66fe2a60